import { gql } from '@apollo/client';

export const TALENT_BASE_FIELDS = gql`
  fragment TalentBaseFields on TalentV2 {
    id
    hiresweetId
    firstname
    lastname
    email
    secondaryEmails
    phone
    secondaryPhones
    jobTitle
    status
    bloomerStatus
    remoteWork
    label
    availabilityDate
    image
    comment
    url
    owner
    cv
    tjm
    desiredTjm
    package
    desiredPackage
    origin
    airtableId
  }
`;

export const SEARCH_TALENT = gql`
  query searchTalents($search: TalentV2SearchInput!, $paginate: PaginateInput) {
    searchTalents(search: $search, paginate: $paginate) {
      count
      talents {
        ...TalentBaseFields
        positionTitle {
          jobTitle {
            label
          }
        }
        location {
          city
        }
        profiles {
          url
          network
        }
        skills {
          level
          skill {
            label
          }
        }
        skillLevels {
          level
          skill {
            label
          }
        }
        jobs {
          current
          name
          label
          description
          jobTitle {
            label
          }
          period {
            startDate
            endDate
          }
          skills {
            label
          }
        }
      }
    }
  }
  ${TALENT_BASE_FIELDS}
`;

export const FIND_TALENT = gql`
  query findTalent($id: String!) {
    findTalent(id: $id) {
      ...TalentBaseFields
      positionTitle {
        id
        jobTitle {
          label
        }
      }
      location {
        id
        range
        address
        city
      }
      profiles {
        id
        url
        network
        talentId
      }
      skills {
        id
        level
        skill {
          id
          label
        }
      }
      skillLevels {
        level
        skill {
          id
          label
        }
      }
      jobs {
        id
        current
        name
        label
        description
        jobTitle {
          label
        }
        period {
          id
          startDate
          endDate
        }
        skills {
          label
        }
      }
      educations {
        id
        current
        name
        label
        description
        period {
          startDate
          endDate
        }
        url
      }
      languages {
        id
        label
        level
        talentId
      }
    }
  }
  ${TALENT_BASE_FIELDS}
`;

export const LIST_SKILLS = gql`
  query listSkills($iso: Boolean) {
    listSkills(iso: $iso) {
      id
      label
    }
  }
`;

export const LIST_JOBS = gql`
  query listJobTitles($iso: Boolean!) {
    listJobTitles(iso: $iso) {
      id
      label
      alternateLabels
      iso
    }
  }
`;

export const FIND_JOBS_BY_LABEL = gql`
  query findManyJobTitleFromLabel($label: String!, $iso: Boolean) {
    findManyJobTitleFromLabel(label: $label, iso: $iso) {
      id
      label
    }
  }
`;

export const FIND_SKILLS_BY_LABEL = gql`
  query findManySkillsFromLabel($label: String!) {
    findManySkillsFromLabel(label: $label) {
      id
      label
    }
  }
`;

export const LIST_OWNERS = gql`
  query listOwners {
    listOwners {
      label
      count
    }
  }
`;

export const LIST_LANGUAGES = gql`
  query listLanguages {
    listLanguages {
      label
    }
  }
`;

export const GET_ADDRESSES = gql`
  query getAdresses($input: String!) {
    getAdresses(input: $input) {
      address
      postalCode
      city
      region
      range
      countryCode
      longitude
      latitude
    }
  }
`;

export const GET_LOGS_BY_TALENT = gql`
  query getLogsByTalent($talentId: String!, $paginate: PaginateInput!) {
    getLogsByTalent(talentId: $talentId, paginate: $paginate) {
      logs {
        id
        talent
        tam
        date
        data
        previousData
        source
        type
        jobId
        from
        to
        phaseTransitionDuration
      }
      count
    }
  }
`;

export const JOBTITLES = gql`
  query {
    listJobTitles {
      iso
      label
      id
      alternateLabels
    }
  }
`;

export const SKILLS = gql`
  query ($iso: Boolean) {
    listSkills(iso: $iso) {
      iso
      label
      id
      alternateLabels
    }
  }
`;

export const TALENT_BY_FIELDS = gql`
  fragment TalentByFields on TalentV2 {
    ...TalentBaseFields
    createdAt
    positionTitle {
      id
      jobTitle {
        label
      }
    }
    summary
    cv
    location {
      id
      range
      address
      city
    }
    profiles {
      id
      url
      network
      talentId
    }
    skills {
      id
      level
      skill {
        id
        label
        iso
        alternateLabels
      }
    }
    skillLevels {
      level
      skill {
        id
        label
      }
    }
    jobs {
      id
      current
      name
      label
      description
      jobTitle {
        id
        label
      }
      period {
        id
        startDate
        endDate
      }
      skills {
        label
      }
    }
    educations {
      id
      current
      name
      label
      description
      period {
        id
        startDate
        endDate
      }
      url
    }
    languages {
      id
      label
      level
      talentId
    }
  }
  ${TALENT_BASE_FIELDS}
`;

export const FIND_TALENT_BY_LINKEDIN = gql`
  query findTalentByLinkedin($url: String!) {
    findTalentByLinkedin(url: $url) {
      ...TalentByFields
    }
  }
  ${TALENT_BY_FIELDS}
`;

export const FIND_TALENT_BY_EMAIL = gql`
  query findTalentByEmail($email: String!) {
    findTalentByEmail(email: $email) {
      ...TalentByFields
    }
  }
  ${TALENT_BY_FIELDS}
`;

export const FIND_TALENT_BY_URL = gql`
  query findTalentByUrl($url: String!) {
    findTalentByUrl(url: $url) {
      ...TalentByFields
    }
  }
  ${TALENT_BY_FIELDS}
`;

export const FIND_TALENT_BY_LINKEDIN_LIGHT = gql`
  query findTalentByLinkedin($url: String!) {
    findTalentByLinkedin(url: $url) {
      createdAt
      id
      owner
    }
  }
`;

export const BOOM = gql`
  query boom($errorId: String!) {
    boom(errorId: $errorId) {
      id
    }
  }
`;

export const FIND_TALENT_NONISO_DIRECTJOBTITLES = gql`
  query findTalentsWithNonIsoDirectJobTitles {
    findTalentsWithNonIsoDirectJobTitles {
      id
      fullname
      label
      positionTitle {
        jobTitle {
          label
        }
      }
    }
  }
`;

const JOB_FUNNEL_DEAL_COMMON_SELECTION = `
  id
  name
  jobType
  dealType
  jobTitle

  society {
    name
  }
  accountManager {
    email
    firstname
    lastname
  }

  team
  context
  location
  duration
  onSiteDaysPerWeek
  remoteDaysPerWeek
  expectedStartDate
  details
  scoreCard1
  scoreCard2
  scoreCard3
  scoreCard4
  externalId
  minYearsXP
  maxClientBudget
  clientBudgetDetails
  maxTalentBudget
  outOfBudgetProfil
  budgetDecisionMaker
  isInternalValidation
  clientResearchTrigger
  interviewProcess
  finalValidationResponsable
  minTotalProfilesToInclude
  searchStatus
  competitors
  isExclusivity
  cvDebriefDate
  isResponsiveClient
  isReliableClient
  isDirectLinkWithDecisionMaker
  priority
  isBloomerReplacement
  isQuickContract
  status
  lostReason
  otherLostReason
  bloomerSource
  commercialMonth
  passeur
  buteur
  capitaine
  defenseur
  requiredLanguages
  interlocuteur1Email
  interlocuteur2Email
  createdAt
  hubspotDealId
  airtableId
  pipefyId
  hiresweetId
  winDate
`;

export const JOB_FUNNEL_BASE_FIELDS = gql`
  fragment JobFunnelBaseFields on GqlJobFunnel {
    ${JOB_FUNNEL_DEAL_COMMON_SELECTION}
  }
`;

export const DEAL_JOB_FUNNEL_FIELDS = gql`
  fragment DealJobFunnelFields on GqlDealJobFunnel {
    ${JOB_FUNNEL_DEAL_COMMON_SELECTION}
    leadCustomerStatus
    leadCanal
    leadOrigin
    leadCanalDetail
  }
`;

export const GET_JOB_FUNNEL_BY_ATS_ID = gql`
  query getJobFunnelByAtsId($atsId: String!) {
    getJobFunnelByAtsId(atsId: $atsId) {
      ...JobFunnelBaseFields
    }
  }
  ${JOB_FUNNEL_BASE_FIELDS}
`;

export const GET_DEAL_AND_JOB_FUNNEL_TALENTS = gql`
  query getJobFunnelProjectWithTalents($jobId: String!) {
    getJobFunnelProjectWithTalents(jobId: $jobId) {
      job {
        ...DealJobFunnelFields
      }
      talents {
        id
        firstname
        lastname
        email
        jobTitle
      }
      bloomer {
        id
        firstname
        lastname
        email
        jobTitle
      }
    }
  }
  ${DEAL_JOB_FUNNEL_FIELDS}
`;

export const GET_JOB_FUNNEL_PROJECTS = gql`
  query getJobFunnelProjects($status: StatusType) {
    getJobFunnelProjects(status: $status) {
      ...JobFunnelBaseFields
    }
  }
  ${JOB_FUNNEL_BASE_FIELDS}
`;

export const GET_CURRENT_PROJECTS_PER_CLIENT = gql`
  query getCurrentProjectsPerClient {
    getCurrentProjectsPerClient {
      ...JobFunnelBaseFields
    }
  }
  ${JOB_FUNNEL_BASE_FIELDS}
`;

export const TALENT_FOR_TALENT_BOARD_FIELDS = gql`
  fragment TalentForTalentBoardFields on GqlTalentForTalentBoard {
    id
    firstname
    lastname
    email
    jobTitle
    image
    availabilityDate
    location {
      id
      city
    }
    tjm
    package
    profiles {
      id
      username
      network
      url
      talentId
    }
    cv
    jobs {
      id
      jobTitle {
        id
        label
        iso
      }
      period {
        id
        startDate
        endDate
      }
      current
      label
      description
      name
      skills {
        id
        label
        iso
        alternateLabels
      }
    }
    educations {
      id
      name
      label
      description
      current
      url
      type
      period {
        id
        startDate
        endDate
      }
    }
    languages {
      id
      label
      level
    }
    phase
    phaseNotes {
      id
      phaseId
      date
      answers
      jobId
      talentId
      source
      externalId
    }
    topProfile
    becameBloomer
    cardTamComment
    comments {
      id
      jobId
      talentId
      comment
      author
      createdAt
      updatedAt
    }
    generalTamEvaluation
    addedInProject
    markedAsSeen
    dateMarkedAsSeen
  }
`;

export const GET_TALENTS_FOR_TALENT_BOARD = gql`
  query getTalentsForTalentBoard($jobId: String!) {
    getTalentsForTalentBoard(jobId: $jobId) {
      ...TalentForTalentBoardFields
    }
  }
  ${TALENT_FOR_TALENT_BOARD_FIELDS}
`;

export const GET_TALENT_BOARD_STATS = gql`
  query getTalentBoardStats($jobId: String!) {
    getTalentBoardStats(jobId: $jobId) {
      contacted
    }
  }
`;

export const GET_TALENT_FOR_TALENT_BOARD = gql`
  query getTalentForTalentBoard($talentId: String!, $jobId: String!) {
    getTalentForTalentBoard(talentId: $talentId, jobId: $jobId) {
      ...TalentForTalentBoardFields
    }
  }
  ${TALENT_FOR_TALENT_BOARD_FIELDS}
`;

export const GET_INVITATIONS = gql`
  query getInvitations($jobId: String!) {
    getInvitations(jobId: $jobId) {
      id
      jobId
      email
      createdAt
      createdBy
      resentAt
    }
  }
`;

export const GET_TALENT_BOARD_EVENTS = gql`
  query getTalentBoardEvents($jobId: String!) {
    getTalentBoardEvents(jobId: $jobId) {
      id
      jobId
      date
      authorEmail
      type
      data {
        ... on GqlTalentBoardEventTalentData {
          talentId
          talentFullName
        }
        ... on GqlTalentBoardEventInvitationData {
          email
        }
      }
    }
  }
`;

export const GET_TALENT_BOARD_EVENT_KPIS = gql`
  query getTalentBoardEventKpis($jobId: String!) {
    getTalentBoardEventKpis(jobId: $jobId) {
      talentBoardOpened
      talentViewed
      commentUpserted
    }
  }
`;
